<template>
  <div class="free-transfers-badge" data-testid="free-transfers-badge">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "FreeTransfersBadge",
  props: {
    message: {
      type: String,
      default: "You have 12 FREE Transfers!"
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";

.free-transfers-badge {
  background-color: $brand-600;
  color: $white;
  font-size: 14px;
  font-weight: 700;
  padding: 4px 6px;
  border-radius: 8px;
  white-space: nowrap;
  line-height: 20px;
}
</style>
